export const MAX_CONTENT_LENGTH = 200;
